import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AutoCompleteOptionType } from '../../../components/molecules/autocompleteTypes';
import FilterAutoComplete from '../FilterAutoComplete/FilterAutoComplete';

const MetricDropdown = ({ options, filtersRef, field, onValueChange, initialValue, label, openUpward }) => {
    const [value, setValue] = useState(initialValue);

    const handleChange = useCallback(
        newValue => {
            setValue(newValue);
            filtersRef.current[field] = newValue;
            onValueChange?.(newValue);
        },
        [filtersRef, field, onValueChange]
    );

    useEffect(() => {
        if (initialValue && !value) {
            setValue(initialValue);
            filtersRef.current[field] = initialValue;
        }
    }, [initialValue, filtersRef, field]);

    return (
        <FilterAutoComplete
            options={options}
            value={value}
            onChange={handleChange}
            label={label}
            openUpward={openUpward}
        />
    );
};

MetricDropdown.propTypes = {
    options: PropTypes.arrayOf(AutoCompleteOptionType).isRequired,
    filtersRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    field: PropTypes.string.isRequired,
    onValueChange: PropTypes.func,
    initialValue: AutoCompleteOptionType,
    label: PropTypes.string,
    openUpward: PropTypes.bool,
};

export default MetricDropdown;
